import { render, staticRenderFns } from "./AddContactForm.vue?vue&type=template&id=206fb3a8&scoped=true"
import script from "./AddContactForm.vue?vue&type=script&lang=js"
export * from "./AddContactForm.vue?vue&type=script&lang=js"
import style0 from "./AddContactForm.vue?vue&type=style&index=0&id=206fb3a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206fb3a8",
  null
  
)

export default component.exports